//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, tool, commonData } from "@/mixins/index";
import bindPhone from "./components/bindPhone";
export default {
  name: "oauthList",
  mixins: [loadMoreList, tool, commonData],
  components: {
    bindPhone: bindPhone
  },
  data: function data() {
    return {
      pagingReqFn: "oauthList",
      paramsData: {
        o_type: '',
        isMustAppid: 1
      },
      columns: []
    };
  },
  created: function created() {},
  activated: function activated() {
    this.getcommonData(['appListAllData']);
  },
  methods: {
    exportDataFn: function exportDataFn() {
      this.columns = [{
        label: '用户ID',
        prop: 'user_id'
      }, {
        label: '网关用户ID',
        prop: 'gate_user_id'
      }, {
        label: '登录类型名称',
        prop: 'o_type_name'
      }, {
        label: '登录类型',
        prop: 'o_type'
      }, {
        label: '第三方ID',
        prop: 'open_id'
      }, {
        label: '创建时间',
        prop: 'create_time'
      }];
      this.exportData();
    }
  }
};